<div class="map" [id]="mapId" class="match-parent"></div>
